import { afterScreenshot as _afterScreenshot } from './prePostScreenshot';
import { getBugherd } from '../models/Application';

export const getViewport = viewport => ({
  scale: viewport.scale,
  pageLeft: viewport.pageLeft,
  pageTop: viewport.pageTop,
  offsetTop: viewport.offsetTop,
  offsetLeft: viewport.offsetLeft,
  width: viewport.width,
  height: viewport.height
});

export const scrollbarCheck = document => {
  const elementToCheck =
    document.compatMode === 'BackCompat'
      ? document.body
      : document.documentElement;
  if (elementToCheck) {
    if (Math.abs(elementToCheck.scrollHeight - elementToCheck.clientHeight)) {
      let outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.position = 'absolute';
      outer.style.top = '-99999px';
      outer.style.width = '100px';

      document.body.appendChild(outer);

      const widthNoScroll = outer.offsetWidth;
      outer.style.overflow = 'scroll';
      let inner = document.createElement('div');
      inner.style.width = '100%';
      outer.appendChild(inner);

      const widthWithScroll = inner.offsetWidth;

      outer.parentNode.removeChild(outer);

      return widthNoScroll - widthWithScroll;
    }
  }
  return 0;
};

export const getStyledComponentCSSRules = documentObject => {
  if (!documentObject) {
    return null;
  }

  let cssRuleTexts = [];

  const styledQuerySelectors = [
    'style[data-styled]',
    'style[id="react-native-stylesheet"]'
  ];

  styledQuerySelectors.forEach(selector => {
    // this is specific to styled components as they are not included in the docElement.
    const styleElement = documentObject.querySelector(selector);

    if (styleElement && styleElement.sheet) {
      const styledCSSRule = Array.from(styleElement.sheet.cssRules);

      cssRuleTexts = [
        ...cssRuleTexts,
        ...styledCSSRule.map(cssRule => cssRule.cssText)
      ];
    }
  });

  return cssRuleTexts;
};

const getOffsetsAndInputs = documentObject => {
  const allElements = Array.from(documentObject.getElementsByTagName('*'));
  let offsets = {};
  let inputs = {};

  allElements.forEach((element, index) => {
    let offset = { x: 0, y: 0 };
    if (element.scrollLeft) {
      offset.x = element.scrollLeft;
    }
    if (element.scrollTop) {
      offset.y = element.scrollTop;
    }
    if (offset.x || offset.y) {
      offsets[index] = offset;
    }

    if ('value' in element) {
      inputs[index] = {
        value: element.value
      };
    }

    if ('checked' in element) {
      if (inputs[index]) {
        inputs[index].checked = element.checked;
      } else {
        inputs[index] = {
          checked: element.checked
        };
      }
    }
  });
  return { offsets, inputs };
};

export const polyfillScreenshot = (
  windowObject,
  documentObject,
  visualViewport,
  basicAuthPresent,
  basicAuthUrl,
  userId,
  organizationId
) => {
  let base = null;
  if (!documentObject.getElementsByTagName('base').length) {
    base = documentObject.createElement('base');
    base.href = windowObject.location.origin;
    documentObject.head.appendChild(base);
  }

  const { offsets, inputs } = getOffsetsAndInputs(documentObject);

  const data = {
    properties: {
      url: windowObject.location.href,
      innerWidth: documentObject.documentElement.clientWidth,
      innerHeight: documentObject.documentElement.clientHeight,
      scrollTop: windowObject.scrollY,
      scrollLeft: windowObject.scrollX,
      userAgent: windowObject.navigator.userAgent,
      devicePixelRatio: windowObject.devicePixelRatio,
      offsets: offsets,
      viewport: visualViewport ? getViewport(visualViewport) : 0,
      scrollbarWidth: scrollbarCheck(documentObject),
      inputs: inputs
    },
    basicAuthPresent: basicAuthPresent,
    basicAuthUrl: basicAuthUrl,
    documentElement: documentObject.documentElement.innerHTML.replace(
      /(\r\n|\n|\r)/gm,
      ''
    ),
    documentStyleSheets: getStyledComponentCSSRules(documentObject),
    userId: userId,
    organizationId: organizationId
  };

  if (base) {
    documentObject.head.removeChild(base);
  }
  return data;
};

const getScreenshotPolyfill = ({
  _window = getBugherd().parentPage.window,
  _document = getBugherd().parentPage.document,
  _visualViewport = getBugherd().parentPage.window._bugHerd.visualViewport,
  basicAuthPresent = !!getBugherd().application.get('basic_auth_password') &&
    !!getBugherd().application.get('basic_auth_username'),
  basicAuthUrl = `${getBugherd()
    .application.get('bugherdUrl')
    .replace(
      'sidebar.',
      'www.'
    )}/api_v0/projects/${getBugherd().application.get('projectId')}`,
  afterScreenshot = _afterScreenshot,
  userId = getBugherd().application.get('currentUserId') === -1
    ? null
    : getBugherd().application.get('currentUserId'),
  organizationId = getBugherd().application.get('organizationId')
} = {}) => {
  return new Promise(resolve => {
    const details = {
      screenshotPolyfill: polyfillScreenshot(
        _window,
        _document,
        _visualViewport,
        basicAuthPresent,
        basicAuthUrl,
        userId,
        organizationId
      )
    };
    afterScreenshot();
    resolve(details);
  });
};

export default getScreenshotPolyfill;
